<template>
<div>
    <b-avatar :size="size" :src="path" ></b-avatar>
</div>
</template>

<script>
export default {
  props: {
    size : {
        type: String
    }
   
  },
    name: "Avatar",
    data() {
        return {
            path: ''
        }
    },
    mounted() {
        this.getPath()
    },

    methods: {
       getPath() {
        axios.get('/user/getPath')
        .then((response) => {
            this.path = response.data.path
        })
       }
    },

}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/util/Avatar.vue